(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('contact_form');
    if (!form) return;
    form.addEventListener('submit', handleFormSubmit);
  });

  let isSubmitting = false;

  async function handleFormSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    if (isSubmitting) return; // prevent double submission
    isSubmitting = true;

    const formData = new FormData(form);

    try {
      // Add tracking parameters from ddr-tracking.liquid
      try {
        if ('localStorage' in window) {
          const trackingParams = await localStorage.getItem('ddrt');
          if (trackingParams) formData.append('tracking_params', JSON.stringify(trackingParams));
        }
      } catch {}

      // Create draft order
      if (!form.dataset.endpoint) throw new Error('Missing endpoint for contact form');
      await fetch(form.dataset.endpoint, { method: 'POST', body: formData, keepalive: true });

      // Trigger Shopify analytics event
      Shopify.analytics.publish('custom:form_submitted', Object.fromEntries(formData));
    } catch (error) {
      console.error('Error creating draft order:', error);
    } finally {
      // Submit the form normally
      form.submit();
      isSubmitting = false;
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-specs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const specsContainer = document.querySelector('[data-specs-container]');
    if (!specsContainer) return;

    document.addEventListener('shopify:variant:change', async (event) => {
      const variant = event.detail?.variant;
      if (!variant) return;

      const sectionId = specsContainer.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
      if (!sectionId) return;

      try {
        const url = `${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`;
        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSpecs = doc.querySelector('[data-specs-container]');

        if (newSpecs) {
          specsContainer.innerHTML = newSpecs.innerHTML;
        } else {
          specsContainer.innerHTML = '';
        }
      } catch (error) {
        console.error('Error updating specs:', error);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
